import React, { useState } from 'react';
import beograd from '../../assets/contact.png';
import './contact.css';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

function Contact() {
  const { t } = useTranslation('global');

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const sendEmail = async (e) => {
    e.preventDefault();

    const serviceId = 'service_yesibye';
    const templateId = 'template_j73xun9';
    const publicKey = 'Q4Hba7DTP-1MCAkWA';

    const data = {
      service_id: serviceId,
      template_id: templateId,
      user_id: publicKey,
      template_params: {
        from_name: name,
        from_email: email,
        to_name: 'Web Site',
        message: message,
      },
    };

    try {
      const res = await axios.post(
        'https://api.emailjs.com/api/v1.0/email/send',
        data
      );
      if (res.data === 'OK') {
        alert(t('contact.successful_message'));
      } else {
        alert(t('contact.unsuccessful_message'));
      }
      setName('');
      setEmail('');
      setMessage('');
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section id="contact" className="contact-block" aria-labelledby="contact-title">
      <div className="bm-container">
        <header className="contact-block__header">
          <p className="contact-block__eyebrow">BeoMedica</p>
          <h1 id="contact-title">{t('contact.title')}</h1>
        </header>

        <div className="contact-block__grid">
          <div className="contact-block__media">
            <img src={beograd} alt="" loading="lazy" />
          </div>

          <div className="contact-block__panel">
            <h3>{t('contact.firma')}</h3>
            <p>{t('contact.address')}</p>
            <p>
              <a href="tel:+381114508418">{t('contact.phone')}</a>
            </p>
            <p>
              <a className="contact-block__email" href={`mailto:${t('contact.email')}`}>
                {t('contact.email')}
              </a>
            </p>
            <p className="contact-block__note">{t('contact.pitanja')}</p>

            <form className="contact-block__form" onSubmit={sendEmail}>
              {/* Form UI currently inactive in production content */}
              {/* <div className="contact-block__fields">
                <input type="text" placeholder={t("contact.field_ime")} value={name} onChange={(e) => setName(e.target.value)} />
                <input type="email" placeholder={t("contact.field_email")} value={email} onChange={(e) => setEmail(e.target.value)} />
                <textarea placeholder={t("contact.field_message")} value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
                <input type="submit" value={t("contact.button_formSubmit")} />
              </div> */}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
